import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { CalculatedWorkDemand } from 'components/types';

import { Box, Button } from '@mui/material';

import { SkeletonWithIcon } from 'components/shared';
import NoDataPlaceholder from 'components/shared/NoDataPlaceholder';

import WorkDemandTotalsGraph from './WorkDemandTotalsGraph';
import WorkDemandTotalsTable from './WorkDemandTotalsTable';
import { StyledPaper } from 'components/shared/Paper/StyledPaper.styles';

type Props = {
  isLoading: boolean;
  totalWorkDemand: CalculatedWorkDemand | null;
};

const hasCapacityFinancialAccess = false; // Disabled for now, can be re-enabled later

const WorkDemandTotals = ({ isLoading, totalWorkDemand }: Props) => {
  const [isShowHours, setIsShowHours] = useState<boolean>(true);
  const [isViewGraph, setIsViewGraph] = useState<boolean>(true);

  const { t } = useTranslation('common');

  const renderContent = () => {
    const Component = isViewGraph
      ? WorkDemandTotalsGraph
      : WorkDemandTotalsTable;

    return (
      <Component isShowHours={isShowHours} totalWorkDemand={totalWorkDemand} />
    );
  };

  return (
    <Box>
      <Box
        position="relative"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Box display="flex" ml="auto" gap={2}>
          {hasCapacityFinancialAccess && (
            <Button
              variant="outlined"
              onClick={() => setIsShowHours(!isShowHours)}
            >
              {isShowHours
                ? t('workDemand.showEuros')
                : t('workDemand.showHours')}
            </Button>
          )}
          <Button
            variant="outlined"
            onClick={() => setIsViewGraph(!isViewGraph)}
          >
            {isViewGraph ? t('showTable') : t('showGraph')}
          </Button>
        </Box>
      </Box>
      {isLoading && isViewGraph ? (
        <SkeletonWithIcon height={400} />
      ) : (
        <>
          {totalWorkDemand?.rows.length ? (
            renderContent()
          ) : (
            <StyledPaper>
              <NoDataPlaceholder title={t('noDataForThisScenario')} />
            </StyledPaper>
          )}
        </>
      )}
    </Box>
  );
};

export default WorkDemandTotals;
